import {HTMLElementNode} from "./html-element-node";
/**
 * Classe que cria uma lista ligada a partir de um elemento HTML.
 */
export class HTMLElementLinkedList {
    static fromHtmlString(htmlString) {
        const div = document.createElement('div');
        div.innerHTML = htmlString;

        return new HTMLElementLinkedList(div);
    }

    /** @type {HTMLElementNode | null} */
    head;

    /**
     * @param {HTMLElement} rootElement - O elemento HTML a ser convertido em uma lista ligada.
     */
    constructor(rootElement) {
        this.head = this.createLinkedListFromElement(rootElement);
    }

    /**
     * Função recursiva para criar a lista ligada a partir de um elemento HTML.
     * @param {HTMLElement} element - O elemento HTML a ser convertido.
     * @returns {HTMLElementNode | null} - O primeiro nó da lista ligada contendo o elemento HTML e seu conteúdo.
     */
    createLinkedListFromElement(element) {
        /** @type {HTMLElementNode | null} */
        let head = null;
        /** @type {HTMLElementNode | null} */
        let currentNode = null;

        /**
         * Função auxiliar para adicionar um nó à lista ligada.
         * @param {string} value - O valor do nó a ser adicionado.
         */
        const appendNode = (value) => {
            const newNode = new HTMLElementNode(value);
            if (head === null) {
                head = newNode;
            } else if (currentNode) {
                currentNode.next = newNode;
            }
            currentNode = newNode;
        };

        // Adiciona a tag de abertura do elemento
        appendNode(`<${element.tagName.toLowerCase()}>`);

        // Verifica se o elemento é uma lista (ul, ol)
        if (element.tagName.toLowerCase() === 'ul' || element.tagName.toLowerCase() === 'ol') {
            element.childNodes.forEach((child) => {
                if (child instanceof HTMLElement && child.tagName.toLowerCase() === 'li') {
                    // Adiciona a tag de abertura do item da lista
                    appendNode(`<li>`);
                    // Processa o conteúdo do <li>
                    child.childNodes.forEach((liChild) => {
                        if (liChild.nodeType === Node.TEXT_NODE) {
                            // Adiciona o texto dentro do <li>
                            const textContent = liChild.textContent || '';
                            for (let char of textContent) {
                                appendNode(char);
                            }
                        } else if (liChild instanceof HTMLElement) {
                            // Se o <li> tiver elementos HTML internos, processa-os recursivamente
                            const liChildLinkedList = this.createLinkedListFromElement(liChild);
                            if (currentNode) {
                                currentNode.next = liChildLinkedList;
                                while (currentNode && currentNode.next) {
                                    currentNode = currentNode.next;
                                }
                            }
                        }
                    });
                    // Adiciona a tag de fechamento do item da lista
                    appendNode(`</li>`);
                }
            });
        } else {
            // Processa elementos não relacionados a listas
            element.childNodes.forEach((child) => {
                if (child instanceof HTMLElement) {
                    // Se o nó filho é um outro elemento HTML, faz a chamada recursiva
                    const childLinkedList = this.createLinkedListFromElement(child);
                    if (currentNode) {
                        currentNode.next = childLinkedList;
                        while (currentNode && currentNode.next) {
                            currentNode = currentNode.next;
                        }
                    }
                } else if (child.nodeType === Node.TEXT_NODE) {
                    // Divide o texto em várias partes e adiciona cada parte separadamente
                    const textContent = child.textContent || '';
                    for (let char of textContent) {
                        appendNode(char);  // Adiciona cada caractere de texto separadamente
                    }
                }
            });
        }

        // Adiciona a tag de fechamento do elemento
        appendNode(`</${element.tagName.toLowerCase()}>`);

        return head;
    }
}




// WEBPACK FOOTER //
// ./src/mixins/html-writer/html-element-linked-list.js